module.exports = __webpack_public_path__ + "static/media/rowing.6eedf827.png";